import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import { Button } from '@fluentui/react-components';
import { usePolyAuth } from '../hooks/PolyAuthContext';
import { useTranslation } from 'react-i18next';

const LoginPanel = () => {
  const { t } = useTranslation('shared');
  const { login } = usePolyAuth();
  const handleLoginClick = async() => {
    try {
      await login();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    < >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px',
        flexDirection: 'column',
        gap: 3
      }}>

        <Typography variant="h5"
                    component="h1" sx={{ mb: 3, textAlign: 'center' }}>
          {t('loginPanel.prompt')}
        </Typography>
        <Button
          appearance="primary"
          onClick={handleLoginClick}
          sx={{
            minWidth: '200px',
          }}
        >
          {t('loginPanel.login')}
        </Button>
      </Box>
    </>
  );
};

export default LoginPanel; 